import { Language } from 'client/graphql/types/operations';
import i18n from 'client/i18n';
import { isLanguage } from 'client/utils/isLanguage';

export const getLanguage = () => {
  const language = (i18n.language ?? localStorage.getItem('i18nextLng'))
    ?.replace(/-\w+$/, '')
    .toUpperCase();

  if (!isLanguage(language)) {
    return Language.En;
  }

  return language;
};
